import 'bootstrap/dist/css/bootstrap.css'
import { createApp } from 'vue'
import { createStore } from 'vuex'
import { getFirestore } from "firebase/firestore";
import { doc, setDoc, getDoc, getDocs, onSnapshot, collection } from "firebase/firestore";
import { getAuth, signInAnonymously, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";




import App from './App.vue'
import { initializeApp } from "firebase/app";
import router from './router'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCf3reXNSv2PaBuQad3llqGM7di7PdCiaA",
  authDomain: "talent-show-3ed20.firebaseapp.com",
  projectId: "talent-show-3ed20",
  storageBucket: "talent-show-3ed20.appspot.com",
  messagingSenderId: "588872234906",
  appId: "1:588872234906:web:aadd01225aeb2fe0cdac23",
  measurementId: "G-JQW1V1K9SS"
};
const fire = initializeApp(firebaseConfig);
const db = getFirestore(fire);
const auth = getAuth();

const store = createStore({
  state () {
    return {
      count: 0,
    vote:undefined,
    uid: null,
    isLogged: false,
    loadedConf: false,
    activated: false,
    endTime: 0,
    members: {},
    resCollection: null,
    votes: null,
    adminUID: 'Egeor7pNZaQ2URxTtQqDYNIPYJn1'
        
        
    }
  },
  mutations: {
    increment (state) {
      state.count++
        if(state.count>100){
        setDoc(doc(db, "cities", 'd'), {
          name: "PATRYCJA123",
          state: "CA",
          country: "USA"
        });}
        
    },
      
      setConf(state, params){
          state.activated = params.activated;
          state.endTime = params.endtime;
          state.members = params.members;
          state.resCollection = params.rescollection;
          state.loadedConf = true;
      },
      setUID(state, uid){
          state.uid = uid;
          state.isLogged = true;
          
      },
      setVote(state, vote){
          state.vote = vote;
          
      },
      setVotes(state, votes){
          state.votes = votes;
          
      }
  },
    actions: {
        async onLogin(context){
            onAuthStateChanged(auth, (user) => {
              if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/auth.user
                  context.commit('setUID', user.uid)
                // ...
              } else {
                // User is signed out
                // ...
              }
            });
        },
        async loginAsAdmin (context, password) {
            signInWithEmailAndPassword(auth, 'patrycjakonarska93@gmail.com', password)
              .then((result) => {
                console.log(result)
              })
              .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                  console.log(errorCode+errorMessage)
                  console.log(password)
               
              });

        },
        async loadConf ({ commit, dispatch, state }, mode) {
            onSnapshot(doc(db, "settings", "CONF"), (doc) => {
                //console.log(doc.data())
                commit('setConf', doc.data())
                if(mode == 'home'){
                     dispatch('loadVote');
                }
                if(mode == 'results'){
                    if(state.votes == null && state.endTime < Date.now()) dispatch('loadVotes');
                }
            });
        },
        async loginAsAnon ({commit, dispatch}) {
            signInAnonymously(auth)
              .then((result) => {
                commit('setUID', result.user.uid)
                dispatch('loadConf', 'home')
              })
              .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                  console.log(errorCode+errorMessage)
               
              });

        },
        async vote ({commit, state, dispatch}, id) {
            console.log(commit)
            console.log(state.uid)
            console.log(id)
            await setDoc(doc(db, 'results/'+state.resCollection+'/votes', state.uid), {
              member: id
            });
            dispatch('loadVote');
        },
        async startVoting ({commit}, memberListId) {
            let members = {
                0:'Aradhana Meiyappan (singing)',
                1:'Parth Mehra (guitar)',
                2:'Szymon Prokop (singing)',
                3:'Navya Gupta (dancing)',
                4:'Kiara Dutta (saxophone)',
                5:'Liliya Andreyeva (singing)',
                6:'Deeksha Rohit (dancing)',
                7:'Kateryna Velyka (piano)',
                8:'Ayat Siddiqui (singing)',
                9:'Kalp Jha (stand-up comedy)',
                10:'Teryn Kim (piano)',
                11:'Srushti Gite (dancing)',
                12:'Aarvi Talekar (singing)'
                
            };
            if(memberListId == 1){
                members = {
                    0:'Davyd Petrov (piano)',
                    1:'Joshna Prasad Sangeetha (backward counting)',
                    2:'Anastasiia Shtukaturova (singing)',
                    3:'Ayansh Goel (ukulele)',
                    4:'Rishi Bysani (piano)'
                }
            }
            let endTime = Date.now() + 300000
            console.log(commit+memberListId)
            await setDoc(doc(db, 'settings', 'CONF'), {
              activated: true,
              endtime: endTime,
              rescollection: Date.now(),
            members: members
                
                             
            });
            
        },
        async loadVote ({commit, state}) {
            console.log("SSS:"+state.uid)
            const docSnap = await getDoc(doc(db, 'results/'+state.resCollection+'/votes', state.uid));
            if (docSnap.exists()) {
              commit('setVote', docSnap.data().member)
            } else {
                commit('setVote', -1)
              // doc.data() will be undefined in this case
              console.log("No such document!");
            }
        },
        async loadVotes ({ state, commit}) {
            let arr = Array.apply(null, Array(50)).map(Number.prototype.valueOf,0);

            const querySnapshot = await getDocs(collection(db, 'results/'+state.resCollection+'/votes'));
            
            console.log(querySnapshot)
            querySnapshot.forEach((doc) => {
              console.log(doc.id, " => ", doc.data());
              if(doc.data().member > -1 && doc.data().member <50) arr[doc.data().member]++
            });
            commit('setVotes', arr)
        },
        
        
    }
})
const app = createApp(App).use(router)
// Initialize Firebase


app.use(store)
app.mount('#app')
import 'bootstrap/dist/js/bootstrap.js'
